import { render, staticRenderFns } from "./TimeFormatter.vue?vue&type=template&id=aecdd8dc&scoped=true&"
import script from "./TimeFormatter.vue?vue&type=script&lang=js&"
export * from "./TimeFormatter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aecdd8dc",
  null
  
)

export default component.exports